const steps = [
  {
    name: "make",
    type: "List",
    api: true
  },
  {
    name: "model",
    type: "List",
    api: true
  },
  {
    name: "year",
    type: "List",
    api: true
  },
  {
    name: "month",
    type: "List",
    api: false
  },
  {
    name: "bodytype",
    type: "List",
    api: true
  },
  {
    name: "fuel",
    type: "List",
    api: true
  },
  {
    name: "power",
    type: "List",
    api: true
  },
  {
    name: "engine",
    type: "List",
    api: true
  },
  {
    name: "equipment",
    type: "List",
    api: true
  },
  {
    name: "extras",
    type: "Extras",
    api: true
  },
  {
    name: "mileage",
    type: "Mileage",
    api: false
  },
  {
    name: "purpose",
    type: "Purpose",
    api: false
  },
  {
    name: "email",
    type: "Email",
    api: false
  },
  {
    name: "valuation",
    type: "Intermission",
    api: false
  }
]

const widgetSteps = [
  {
    name: "dealerForm",
    type: "DealerEmail",
    api: false
  },
  {
    name: "valuation",
    type: "DealerIntermission",
    api: false
  }
]

export const Flow = {

    firstStep: function () {
      return steps[0];
    },

    next: function(stepName) {
      const current = this.step(stepName);
      if(current == null) {
        return steps[0];
      } else {
        const nextStepIndex = steps.indexOf(current) + 1;
        return steps[nextStepIndex];
      }
    },

    prev: function(stepName) {
      const current = this.step(stepName);

      if(current == null || steps.indexOf(current) == 0) {
        return steps[0];
      } else {
        const prevStepIndex = steps.indexOf(current) - 1;
        return steps[prevStepIndex];
      }
    },

    resetSteps: function(currentStepName) {
      const cutOff = steps.indexOf(this.step(currentStepName));
      return steps.slice(cutOff + 1, steps.length + 1);
    },

    step: function(name) {
      return steps.find(function(element) {
        return element.name == name;
      });
    },

  isActiveStep: function (store, name) {
      const currentStepIndex   = steps.indexOf(this.step(store.state.step || this.firstStep().name));
      const testIndex = steps.indexOf(this.step(name));

      if (store.state.widget && store.state.selected[name] !== null) {
        return true;
      }

      return currentStepIndex >= testIndex;
    },

    widgetSetup: function() {
      steps.splice(-3, 3, ...widgetSteps);
    }
};



// WEBPACK FOOTER //
// ./src/services/flow.js